import { render, staticRenderFns } from "./UpdateSaleForm.vue?vue&type=template&id=42fa7e90"
import script from "./UpdateSaleForm.vue?vue&type=script&lang=js"
export * from "./UpdateSaleForm.vue?vue&type=script&lang=js"
import style0 from "./UpdateSaleForm.vue?vue&type=style&index=0&id=42fa7e90&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports